<template>
  <div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <!--
      Background backdrop, show/hide based on modal state.
  
      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
  
    <div class="fixed inset-0 z-10 overflow-y-auto">
      <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <!--
          Modal panel, show/hide based on modal state.
  
          Entering: "ease-out duration-300"
            From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            To: "opacity-100 translate-y-0 sm:scale-100"
          Leaving: "ease-in duration-200"
            From: "opacity-100 translate-y-0 sm:scale-100"
            To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        -->
        <div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl">
          <form
            id="addEditForm"
            @submit.prevent="onSubmit"
            class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4"
          >
            <div class="space-y-6">
  

              <div>
                <label for="title" class="block text-sm font-medium text-gray-700">
                  Title
                </label>
                <input
                  v-model.trim="formTitle"
                  name="title"
                  id="title"
                  class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm placeholder-gray-400"
                />
                <p v-if="$v.formTitle.$dirty && !$v.formTitle.required" class="mt-2 text-sm text-red-600">
                  Please enter a title.
                </p>
              </div>


              <div>
                <label for="body" class="block text-sm font-medium text-gray-700">
                  Article
                </label>
                <textarea
                  v-model.trim="formBody"
                  name="body"
                  id="body"
                  rows="15"
                  class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm placeholder-gray-400"
                />
                <p v-if="$v.formBody.$dirty && !$v.formBody.required" class="mt-2 text-sm text-red-600">
                  Please enter an article.
                </p>
                <p class="mt-2 text-xs text-gray-600">
                  Word count: {{ formBody ? formBody.split(' ').length : 0 }}
                </p>
                <p class="mt-1 text-xs text-gray-600">
                  Include any author notes in double-square brackets, e.g. [[Embed image <span class="break-all">https://en.wikipedia.org/wiki/Plant#/media/File:Cosmarium201512081550.JPG</span>]], [[This next section should appear as a quote.]]
                </p>
              </div>

  
            </div>
            
  
  
          </form>
          <div class="bg-gray-50 px-4 py-3 space-x-3 space-x-reverse flex flex-row-reverse sm:px-6">
            <TailwindButton
              type="submit"
              theme="primary"
              form="addEditForm"
              :disabled="isSaving"
              :loading="isSaving"
            >
              Save
            </TailwindButton>
  
            <TailwindButton
              theme="outline"
              @click="onCancel"
            >
              Cancel
            </TailwindButton>
            <!-- <button type="button" @click="onCancel" class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto">Deactivate</button>
            <button type="button" @click="onSave" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancel</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  </template>
  
  <script>
  import { required } from 'vuelidate/lib/validators'
  import TailwindButton from '../TailwindButton.vue'
  
  import TutorService from '@/services/TutorServices'
  const tutorService = new TutorService()
  
  export default {
    components: { 
      TailwindButton,
    },
    props: {
      articleId: String,
    },
    data() {
      return {
        formTitle: '',
        formBody: '',
        isSaving: false,
      }
    },
    validations: {
      formTitle: { required },
      formBody: { required },
    },
    methods: {
      async onSubmit() {
        this.$v.$touch()
        if (this.$v.$invalid) return
  
        this.isSaving = true
  
        try {
          await tutorService.saveArticle({
            id: this.articleId,
            title: this.formTitle,
            body: this.formBody,
          })
  
          await this.$store.dispatch('refreshUser')
  
          this.$emit('saved')
        }
        catch {
          alert('There was a problem saving your article, please try again.')
        }
        finally {
          this.isSaving = false
        }
      },
      onCancel() {
        this.$emit('close')
      },
    },
    mounted() {
      if (this.articleId) {
        var article = this.$store.getters.user.Articles.find(x => x.Id === this.articleId)
        this.formTitle = article.Title
        this.formBody = article.Body
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  
  </style>